<template>
  <CafeteriaDeliveriesForm :typeEndPoint="'cafeteriaDeliveriesShow'" :dataParams="this.$route.params"/>
</template>
<script>
import CafeteriaDeliveriesForm from '@/components/modules/cafeteria/deliveries/form'
export default {
  name: 'CafeteriaDeliveriesEdit',
  components: {
    CafeteriaDeliveriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/deliveries/edit.vue